import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "UnitOfCost/";

const getUnitOfCosts = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetUnitOfCosts', constants.REQUIRE_INTERCEPTORS);

export {
    getUnitOfCosts
}